import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moldedCandle", "moldVariant", "colorVariant", "moldVariantsContainer", "emptyMessage", "quantity"]
  static values = {
    moldVariants: Array,
    colorVariants: Array
  }

  connect() {
    console.log("Molded candle batch log item controller connected")
    this.selectedMoldVariants = new Set()
    this.currentColorVariantId = null
    this.currentQuantity = 1
    this.updateVariants()
  }

  updateVariants() {
    const moldedCandleId = parseInt(this.moldedCandleTarget.value)

    if (!moldedCandleId) {
      this.disableVariants()
      return
    }

    this.updateMoldVariantsCheckboxes(moldedCandleId)
    this.updateColorVariants(moldedCandleId)
  }

  updateMoldVariantsCheckboxes(moldedCandleId) {
    if (!this.hasMoldVariantsContainerTarget) return

    const container = this.moldVariantsContainerTarget

    // Filter variants for selected molded candle
    const filteredVariants = this.moldVariantsValue.filter(v => v.molded_candle_id === moldedCandleId)

    if (filteredVariants.length === 0) {
      container.innerHTML = '<p class="text-muted text-center mb-0">Aucune variante disponible</p>'
      return
    }

    // Clear container and hide empty message
    container.innerHTML = ''
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.style.display = 'none'
    }

    // Create checkboxes for each variant
    filteredVariants.forEach(variant => {
      const checkboxWrapper = document.createElement('div')
      checkboxWrapper.className = 'form-check'

      const checkbox = document.createElement('input')
      checkbox.type = 'checkbox'
      checkbox.className = 'form-check-input'
      checkbox.value = variant.id
      checkbox.id = `mold_variant_${variant.id}_${this.element.dataset.newRecord || Math.random()}`
      checkbox.dataset.action = 'change->molded-candle-batch-log-item#toggleMoldVariant'

      // Check if this variant was previously selected
      if (this.selectedMoldVariants.has(variant.id)) {
        checkbox.checked = true
      }

      const label = document.createElement('label')
      label.className = 'form-check-label'
      label.htmlFor = checkbox.id
      label.textContent = variant.display_name

      checkboxWrapper.appendChild(checkbox)
      checkboxWrapper.appendChild(label)
      container.appendChild(checkboxWrapper)
    })
  }

  updateColorVariants(moldedCandleId) {
    if (!this.hasColorVariantTarget) return

    const colorSelect = this.colorVariantTarget
    const currentColorId = colorSelect.value

    // Clear current options
    colorSelect.innerHTML = '<option value="">Aucune (optionnel)</option>'

    // Filter color variants for selected molded candle
    const filteredColors = this.colorVariantsValue.filter(v => v.molded_candle_id === moldedCandleId)

    // Add filtered color variants
    filteredColors.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.name
      if (variant.id === parseInt(currentColorId)) {
        option.selected = true
      }
      colorSelect.appendChild(option)
    })

    colorSelect.disabled = false
  }

  toggleMoldVariant(event) {
    const variantId = parseInt(event.target.value)

    if (event.target.checked) {
      this.selectedMoldVariants.add(variantId)
    } else {
      this.selectedMoldVariants.delete(variantId)
    }

    this.syncHiddenFields()
    this.triggerMaterialsUpdate()
  }

  updateColorVariant(event) {
    this.currentColorVariantId = event.target.value || null
    this.triggerMaterialsUpdate()
  }

  updateQuantity(event) {
    this.currentQuantity = parseInt(event.target.value) || 1
    this.triggerMaterialsUpdate()
  }

  triggerMaterialsUpdate() {
    // Dispatch event to the parent preparation controller
    const event = new CustomEvent('molded-candle-batch-preparation:updateMaterials', {
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }

  syncHiddenFields() {
    // Set the first selected variant as the primary one (for the current item)
    const firstVariantId = Array.from(this.selectedMoldVariants)[0]
    if (this.hasMoldVariantTarget) {
      this.moldVariantTarget.value = firstVariantId || ''
    }
  }

  createOrUpdateRelatedItems() {
    // This will be handled by creating multiple items on form submission
    // For now, we just need to make sure the materials calculation includes all selected variants
    this.dispatch('variantsChanged', {
      detail: {
        selectedVariants: Array.from(this.selectedMoldVariants),
        colorVariantId: this.currentColorVariantId,
        quantity: this.currentQuantity
      }
    })
  }

  removeGroup(event) {
    // Clean up when removing this item group
    this.selectedMoldVariants.clear()

    // Trigger materials update after a short delay to let cocoon remove the element
    setTimeout(() => {
      this.triggerMaterialsUpdate()
    }, 100)
  }

  disableVariants() {
    if (this.hasMoldVariantsContainerTarget && this.hasEmptyMessageTarget) {
      this.moldVariantsContainerTarget.innerHTML = ''
      const emptyMsg = document.createElement('p')
      emptyMsg.className = 'text-muted text-center mb-0'
      emptyMsg.textContent = 'Sélectionner d\'abord une bougie'
      this.moldVariantsContainerTarget.appendChild(emptyMsg)
    }
    if (this.hasColorVariantTarget) {
      this.colorVariantTarget.disabled = true
      this.colorVariantTarget.innerHTML = '<option value="">Sélectionner d\'abord une bougie</option>'
    }
  }
}

